import type { ReactNode } from 'react';

export const symbol_variable_insert: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-280q-12.75 0-21.37-8.63Q120-297.25 120-310v-340q0-12.75 8.63-21.38Q137.25-680 150-680h660q12.75 0 21.38 8.62Q840-662.75 840-650v140q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-110H180v280h390q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm30-60v-280 280Zm540 23v107q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-180q0-12.75 8.63-21.38Q677.25-420 690-420h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H762l133 133q9 8.8 9 20.9 0 12.1-9.05 21.1-9.06 9-21.5 9-12.45 0-21.45-9L720-317Z"
		/>
	</svg>
);
